import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../config/URL";
import fetchAllCentersWithIds from "../List/CenterList";
import { useNavigate } from "react-router-dom";
import { IoIosSend } from "react-icons/io";

function SendAndPublish({ data, qr, invoiceNotes, uenNumber, id, getData }) {
  const [loadIndicator, setLoadIndicator] = useState(false);
  const [centerData, setcenterData] = useState(null);
  const [selectedId, setSelectedId] = useState("");
  const navigate = useNavigate();

  const centerLogos = {
    "AL @ Hougang":
      "https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/AL+@+Hougang/AL-Hougang-Logo.jpg",
    "AL @ Bukit Batok":
      "https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/AL+@+Bukit+Batok/AL-BukitBatok-Logo.jpg",
    "AL @ Upper Thomson":
      "https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/AL+@+Upper+Thomson/AL-UpperTomson-Logo.jpg",
  };
  const centerQRCodes = {
    "AL @ Hougang":
      "https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/ECS+Centre/images.png",
    "AL @ Bukit Batok":
      "https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/AL+@+Bukit+Batok/AL-BB-QR.jpg",
    "AL @ Upper Thomson":
      "https://smsbucket-for-sms.s3.ap-southeast-1.amazonaws.com/qr_code/AL+@+Upper+Thomson/AL-UT-QR.jpg",
  };

  const centerNames = {
    "AL @ Hougang": "Arty Learning @ HG",
    "AL @ Bukit Batok": "Arty Learning @ BB",
    "AL @ Upper Thomson": "Arty Learning @ UT",
  };

  const centerLogo = centerLogos[data.center] || "--";
  const centerQRCode = centerQRCodes[data.center] || "--";
  const centerName = centerNames[data.center] || "--";

  // const getQRCodeUrl = () => {
  //   if (centerData && data.centerId) {
  //     const center = centerData.find(
  //       (center) => center.id === parseInt(data.centerId)
  //     );
  //     return center ? center.qrCode : "https://example.com/default-qr.png";
  //   }
  //   return "https://example.com/default-qr.png";
  // };

  // Fetch center data to get phone, email, etc.
  useEffect(() => {
    const fetchData = async () => {
      setLoadIndicator(true);
      try {
        const centers = await fetchAllCentersWithIds();
        setcenterData(centers);
        setSelectedId(selectedId);
      } catch (error) {
        toast.error(error.message || "Error fetching data");
      } finally {
        setLoadIndicator(false);
      }
    };
    fetchData();
  }, [selectedId]);

  // Calculate totals for the email template (same as InvoiceView)
  const calculateTotals = () => {
    let totalItemAmount = 0;
    let totalTaxAmount = 0;

    if (data.invoiceItemsDtoList && data.invoiceItemsDtoList.length > 0) {
      data.invoiceItemsDtoList.forEach((item) => {
        totalItemAmount += parseFloat(item.itemAmount) || 0;
        totalTaxAmount += parseFloat(item.gstAmount) || 0;
      });
    }

    return {
      totalItemAmount: totalItemAmount.toFixed(2),
      totalTaxAmount: totalTaxAmount.toFixed(2),
      totalAmount: (totalItemAmount + totalTaxAmount).toFixed(2),
    };
  };

  const { totalItemAmount, totalTaxAmount, totalAmount } = calculateTotals();

  // Get center details for the email template
  const centerPhone =
    centerData &&
    centerData
      .map((center) =>
        parseInt(data.centerId) === center.id ? center.phone || "--" : "",
      )
      .filter(Boolean)[0];

  const centerEmail =
    centerData &&
    centerData
      .map((center) =>
        parseInt(data.centerId) === center.id ? center.email || "--" : "",
      )
      .filter(Boolean)[0];

  const sendEmail = async () => {
    // const qrCodeUrl = getQRCodeUrl();

    try {
      const mailcontent = `<!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>Invoice</title>
          <style>
            * {
              box-sizing: border-box;
              margin: 0;
              padding: 0;
            }

            body {
              margin: 0;
              padding: 0;
              font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
              color: #212529;
            }

            .invoice-box {
              max-width: 800px;
              margin: 0 auto;
              padding: 20px;
              border: 1px solid #dee2e6;
              line-height: 1.5;
              background-color: #fff;
              font-size: 14px;
            }

            .invoice-box img.logo {
              max-width: 100%;
              max-height: 120px;
              display: block;
              margin: 0 auto;
            }
            .header-section {
              text-align: center;
              margin-bottom: 20px;
            }

            .header-section p {
              font-size: 12px;
              margin: 2px 0;
            }

            .header-section p.tagline {
              font-weight: bold;
              margin: 12px 0;
            }

            .header-section p.center-name {
              font-weight: bold;
            }

            .invoice-title {
              text-align: center;
              background-color: #e9ecef;
              padding: 10px;
              font-size: 16px;
              font-weight: bold;
              margin-top: 20px;
            }

            /* Invoice Details using Table for better email client support */
            .invoice-details {
              margin-top: 20px;
              width: 100%;
            }

            .invoice-details table {
              width: 100%;
              border-collapse: collapse;
            }

            .invoice-details td {
              padding: 5px;
              font-size: 12px;
              vertical-align: top;
            }

            .invoice-details td.label {
              width: 120px;
              font-weight: bold;
            }

            .invoice-details td.value {
              width: auto;
            }

            /* Keep the table structure as is */
            .table-wrapper {
              overflow-x: auto; /* Enable horizontal scrolling for table */
              width: 100%;
            }

            .invoice-box table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }

            .invoice-box table th,
            .invoice-box table td {
              padding: 8px;
              text-align: left;
              border-bottom: 1px solid #dee2e6;
              font-size: 12px;
              word-break: break-word; /* Prevent text overflow in table cells */
            }

            .invoice-box table th {
              background-color: #e9ecef;
              font-weight: bold;
            }

            .summary-table {
              width: auto;
              margin-left: auto;
              margin-top: 20px;
              border: none;
            }

            .summary-table td {
              padding: 2px 8px;
              text-align: right;
              font-size: 12px;
              word-break: break-word; /* Ensure totals wrap if needed */
            }

            .summary-table td:first-child {
              font-weight: bold;
            }

            .summary-table tr:last-child td:last-child {
              font-weight: bold;
            }

            /* Footer Section */
            .footer-section {
              margin-top: 20px;
            }

            .footer-section .left,
            .footer-section .right {
              width: 100%;
            }

            .footer-section .right {
              text-align: right;
              margin-top: 20px;
            }

            .footer-section .right img {
              max-width: 150px;
              height: auto;
              margin-bottom: 10px;
            }

            .footer-section .right div {
              margin-bottom: 5px;
              font-size: 12px;
            }

            .footer-section p {
              font-size: 12px;
              margin: 2px 0;
            }

            .footer-section p.label {
              font-weight: bold;
            }

            /* Responsive Design */
            @media only screen and (max-width: 600px) {
              .invoice-box {
                padding: 10px;
                font-size: 12px;
                border: 1px solid #dee2e6;
              }

              .center-title span {
                text: center;
              }

              .header-section p {
                font-size: 10px;
              }

              .invoice-title {
                font-size: 14px;
              }

              .invoice-details td {
                font-size: 10px;
                padding: 3px;
              }

              .invoice-details td.label {
                width: 100px;
              }

              .invoice-box table th,
              .invoice-box table td {
                font-size: 10px;
                padding: 4px;
              }

              .summary-table td {
                font-size: 10px;
                padding: 2px 4px;
              }

              .footer-section .right {
                text-align: left;
                margin-top: 10px;
              }

              .footer-section .right img {
                max-width: 120px;
              }

              .footer-section p,
              .footer-section .right div {
                font-size: 10px;
              }
            }

            @media print {
              .invoice-box {
                border: 0;
              }
            }
              .qr-code-container {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                max-width: 300px; /* Maximum width for larger screens */
                margin: 0 auto; /* Center the container */
                padding: 10px; /* Optional padding for spacing */
              }

              .qr-code-img {
                width: 100%;
                height: auto; /* Maintain aspect ratio */
                max-height: 300px; /* Maximum height to prevent oversized QR codes */
                object-fit: contain; /* Ensure the image fits within the container without distortion */
              }

              /* Responsive adjustments for smaller screens */
              @media (max-width: 768px) {
                .qr-code-container {
                  max-width: 200px; /* Smaller max-width for tablets */
                }
              }

              @media (max-width: 576px) {
                .qr-code-container {
                  max-width: 150px; /* Even smaller for mobile phones */
                }
              }
          </style>
        </head>
        <body>
          <div class="invoice-box">
            <!-- Header Section -->
            <div class="header-section">
              <div class="center-title">
                <img src="${centerLogo}" class="logo" alt="Arty Learning Logo" />
              </div>
              <p class="center-name">${centerName || data.center || "--"}</p>
              <p>Tel: ${centerPhone || "--"}</p>
              <p>Email: ${centerEmail || "--"}</p>
            </div>

            <!-- Invoice Title -->
            <div class="invoice-title">
              Invoice
            </div>

            <!-- Invoice Details -->
            <div class="invoice-details">
              <table>
                <tr>
                  <td class="label">Invoice No</td>
                  <td class="value">: ${data.invoiceNumber || "--"}</td>
                </tr>
                <tr>
                  <td class="label">Student Name</td>
                  <td class="value">: ${data.studentName || "--"}</td>
                </tr>
                <tr>
                  <td class="label">Course Name</td>
                  <td class="value">: ${data.courseName || "--"}</td>
                </tr>
                <tr>
                  <td class="label">Day</td>
                  <td class="value">: ${
                    data.schedule ? data.schedule.split("/")[2] : "--"
                  }</td>
                </tr>
                <tr>
                  <td class="label">Due Date</td>
                  <td class="value">: ${
                    data.dueDate ? data.dueDate.substring(0, 10) : "--"
                  }</td>
                </tr>
                <tr>
                  <td class="label">Date</td>
                  <td class="value">: ${
                    data.invoiceDate ? data.invoiceDate.substring(0, 10) : "--"
                  }</td>
                </tr>
                <tr>
                  <td class="label">Student ID</td>
                  <td class="value">: ${data.studentUniqueId || "--"}</td>
                </tr>
                <tr>
                  <td class="label">Course ID</td>
                  <td class="value">: ${data.schedule || "--"}</td>
                </tr>
                <tr>
                  <td class="label">Course Time</td>
                  <td class="value">: ${data.courseTime || "--"}</td>
                </tr>
              </table>
            </div>

            <!-- Invoice Items Table (Unchanged) -->
            <div class="table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Item</th>
                    <th>Tax Type</th>
                    <th>Item Amount</th>
                    <th>Tax Amount</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  ${
                    data.invoiceItemsDtoList && data.invoiceItemsDtoList.length
                      ? data.invoiceItemsDtoList
                          .map(
                            (invoiceItem, index) => `
                            <tr>
                              <td>${index + 1}</td>
                              <td>${invoiceItem.item || "--"}</td>
                              <td>${
                                invoiceItem.taxType
                                  ? "Tax Type " +
                                    invoiceItem.taxType +
                                    " (Rate TBD)"
                                  : "--"
                              }</td>
                              <td>${invoiceItem.itemAmount || "--"}</td>
                              <td>${invoiceItem.gstAmount || "--"}</td>
                              <td>${invoiceItem.totalAmount || "--"}</td>
                            </tr>
                          `,
                          )
                          .join("")
                      : `<tr><td colspan="6" style="text-align: center;">No items available</td></tr>`
                  }
                </tbody>
              </table>
            </div>

            <!-- Summary Totals (Unchanged) -->
            <table class="summary-table">
              <tbody>
                <tr>
                  <td><strong>Item Amount:</strong></td>
                  <td>${totalItemAmount || "0.00"}</td>
                </tr>
                <tr>
                  <td><strong>Tax Amount:</strong></td>
                  <td>${totalTaxAmount || "0.00"}</td>
                </tr>
                <tr>
                  <td><strong>Total:</strong></td>
                  <td>${totalAmount || "0.00"}</td>
                </tr>
              </tbody>
            </table>

            <!-- Remarks and Footer -->
            <div class="footer-section">
              <div class="left">
                <p class="label">Remarks:</p>
                <p>${data.remark || "--"}</p>
                <p class="label" style="margin-top: 10px;">Notes:</p>
                <p>${invoiceNotes || "--"}</p>
              </div>
              <div class="right">
                <div>
                  <img src="${centerQRCode}" alt="QR Code" class="img-fluid" />
                </div>
                <div>
                  <strong>Arty Learning Pte.Ltd.</strong>
                </div>
                <div>
                  <strong>UEN: ${uenNumber}</strong>
                </div>
              </div>
            </div>
          </div>
        </body>
      </html>`;

      const formData = new FormData();
      formData.append("from", data.parentEmail);
      formData.append("to", data.parentEmail);
      formData.append("subject", "Invoice");
      formData.append("htmlContent", mailcontent);
      setLoadIndicator(true);
      const response = await api.post("/sendMailWithAttachment", formData);
      if (response.status === 201) {
        toast.success(response.data.message);
        getData();
      } else {
        toast.error("Failed to send email");
      }

      setLoadIndicator(false);
    } catch (error) {
      console.error("Error processing request:", error);
      toast.error("Error processing request");
      setLoadIndicator(false);
    }
  };

  return (
    <button className="btn btn-border btn-sm me-1" onClick={sendEmail}>
      {loadIndicator && (
        <span
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
      )}
      <IoIosSend class="text-primary mb-1 me-1" />
      Send and Publish
    </button>
  );
}

export default SendAndPublish;
